// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_2SGQR","xButton":"_2ftQT","blockingLayer":"_9mKKC","content":"hfAwd","actionButton":"EMaKv","expandButton":"_2qccF"};